import React, { useEffect, useState } from 'react';
import './deviceLogin.css';
import AIEduButton from '../../../components/common/Button/AIEduButton';
import AppIcon from '../../../assets/images/AI_Assistant_App_logo.svg';
import microsoftIcon from '../../../assets/images/microsoft_colored_login.png';
import googleIcon from '../../../assets/images/google_colored_login.png';
import { API } from '../../../services';

const DeviceLogin = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const macId = searchParams.get('macId');
    const sessionId = searchParams.get('sessionId');
    const deviceName = searchParams.get('deviceName');

    const [termUrl, setTermUrl] = useState(null);
    const [policyUrl, setPolicyUrl] = useState(null);

    useEffect(() => {
        API.getTermsAndPolicy('orgId').then(({ data }) => {
            const { terms } = data;
            setTermUrl(terms?.[0]?.termUrl);
            setPolicyUrl(terms?.[1]?.termUrl);
        });
    }, []);

    const handleNavigation = () => {
        if (!termUrl) return;
        window.open(termUrl, '_blank');
    };

    const handleNavigationPrivacyPolicy = () => {
        if (!policyUrl) return;
        window.open(policyUrl, '_blank');
    };

    const LOGIN_URL =
        process.env.REACT_APP_AI_ASSISTANCE_HOST + '/ums/auth/login';

    const handleGoogleSignInBtnClick = async () => {
        const updatedDeviceName = deviceName === 'null' ? '--' : encodeURI(deviceName);
        window.location.replace(
            `${LOGIN_URL}?macId=${macId}&sessionId=${sessionId}&deviceName=${updatedDeviceName}`
        );
    };

    const handleMicrosoftSignInBtnClick = async () => {
        const updatedDeviceName = deviceName === 'null' ? '--' : encodeURI(deviceName);
        window.location.replace(
            `${LOGIN_URL}?idp=microsoft&macId=${macId}&sessionId=${sessionId}&deviceName=${updatedDeviceName}`
        );
    };

    const SignInButtonStyle = ({ text, icon, handleClick, className }) => {
        return (
            <AIEduButton
                className={className}
                severity='secondary'
                label={
                    <div className='flex ml-5'>
                        <div className='account_logo'>
                            <img src={icon} />
                        </div>
                        <div className='flex align-items-center'>{text}</div>
                    </div>
                }
                onClick={handleClick}
                outlined
            />
        );
    };

    return (
        <div className='mobile-page-layout'>
            <div className='device-login'>
                <header className='device-header'>
                    <div className='app_logo'>
                        <img src={AppIcon} />
                    </div>
                    <div>Samsung AI Assistant</div>
                </header>
                <main className='main'>
                    <div className='main-header'>Sign In</div>
                    <div className='login-text'>
                        Get started with Samsung AI Assistant
                    </div>
                    <div className='signin-options'>
                        <SignInButtonStyle
                            text='Continue with Google'
                            icon={googleIcon}
                            className='btn btnPrimary'
                            handleClick={handleGoogleSignInBtnClick}
                        />
                        <SignInButtonStyle
                            text='Continue with Microsoft'
                            icon={microsoftIcon}
                            className='btn btnPrimary'
                            handleClick={handleMicrosoftSignInBtnClick}
                        />
                    </div>
                </main>
                <footer className='footer'>
                    <div className='flex justify-content-between'>
                        <div
                            onClick={handleNavigation}
                            className='cursor-pointer hover:underline'
                        >
                            Terms and Condition
                        </div>
                        <div
                            onClick={handleNavigationPrivacyPolicy}
                            className='cursor-pointer hover:underline'
                        >
                            Privacy Policy
                        </div>
                    </div>
                    <div>
                        Copyright &copy; Samsung Electronics Co., Ltd. All
                        Rights Reserved.
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default DeviceLogin;
